"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchUserByTags = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var semantic_ui_react_1 = require("semantic-ui-react");
var i18n_1 = __importDefault(require("../i18n"));
var api_1 = require("../api");
var Users_1 = require("./Users");
var util_1 = require("../util");
var TagsInput_1 = require("./TagsInput");
var ProfileTag_1 = require("./ProfileTag");
var sentry_1 = require("../sentry");
var SearchUserByTags = function (state) {
    (0, react_1.useEffect)(function () {
        searchUsersByTags(state);
    }, []);
    (0, react_1.useEffect)(function () {
        searchUsersByTags(state);
    }, [state.searchParams.tags]);
    return ((0, jsx_runtime_1.jsxs)(semantic_ui_react_1.Dimmer.Dimmable, { dimmed: state.searchUsersLoading, children: [(0, jsx_runtime_1.jsx)(semantic_ui_react_1.Dimmer, { active: state.searchUsersLoading, inverted: true, children: (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Loader, { children: i18n_1.default.loading }) }), (0, jsx_runtime_1.jsxs)(semantic_ui_react_1.Grid, { columns: 1, children: [(0, jsx_runtime_1.jsxs)(semantic_ui_react_1.Grid.Column, { children: [(0, jsx_runtime_1.jsx)(TagsInput_1.TagsInput, {}), (0, jsx_runtime_1.jsx)(ProfileTag_1.ProfileTag, { tags: state.tags, searchTags: state.searchParams.tags, setSearchTags: state.setSearchTags })] }), (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Grid.Column, { children: (0, jsx_runtime_1.jsx)(Users_1.Users, { users: state.searchUsers, menu: true, page: state.page("searchUsers"), setPage: function (page) { return state.setPage("searchUsers", page); }, pageSize: state.usersPageSize, setPageSize: state.setUsersPageSize }) })] })] }));
};
exports.SearchUserByTags = SearchUserByTags;
var searchUsersByTags = function (state) { return __awaiter(void 0, void 0, void 0, function () {
    var idAndUsernames, profiles, users, userModels, e_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                state.requestFetchTags();
                if (!state.searchParams.tags || !state.searchParams.tags.length) {
                    state.setSearchUsers([]);
                    return [2 /*return*/];
                }
                state.setSearchUsersLoading(true);
                _a.label = 1;
            case 1:
                _a.trys.push([1, 7, 8, 9]);
                return [4 /*yield*/, (0, api_1.searchUserIdAndUsernamesByTagNames)(state.searchParams.tags)];
            case 2:
                idAndUsernames = _a.sent();
                if (!!idAndUsernames.length) return [3 /*break*/, 3];
                state.setSearchUsers([]);
                return [3 /*break*/, 6];
            case 3: return [4 /*yield*/, (0, api_1.fetchProfiles)(idAndUsernames.map(function (iu) { return iu.id; }), state)];
            case 4:
                profiles = _a.sent();
                return [4 /*yield*/, (0, api_1.fetchUsersByNames)(idAndUsernames.map(function (iu) { return iu.username; }).filter(function (username) { return username; }))];
            case 5:
                users = _a.sent();
                userModels = (0, util_1.joinUserAndProfiles)(users.map(function (user) { return (__assign(__assign({}, user), { locationInfo: { permission: "none" } })); }), profiles);
                state.setSearchUsers(userModels);
                _a.label = 6;
            case 6: return [3 /*break*/, 9];
            case 7:
                e_1 = _a.sent();
                (0, sentry_1.captureException)(e_1);
                alert(e_1);
                return [3 /*break*/, 9];
            case 8:
                state.setSearchUsersLoading(false);
                return [7 /*endfinally*/];
            case 9: return [2 /*return*/];
        }
    });
}); };
